import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface UpdateTestOutputDto {
  parameters: Record<string, string | null>;
  equipmentName?: string | null;
}

@Injectable({ providedIn: 'root' })
export class TestOutputService {
  private readonly api = inject(ApiService);

  updateParameters(testInputId: number, dto: UpdateTestOutputDto): Observable<void> {
    return this.api.put(`testoutputs/${testInputId}/parameters`, dto);
  }
}
